export const AGENCIES_COLLECTION_NAME = 'agencies';

export enum AgencyDocumentCollections {
  approveDenyReason = 'approve-deny-reason',
  media = 'media',
  fileDirectories = 'fileDirectories',
}

export enum AgencyKeys {
  agencyId = 'agency_id',
  agencyNumber = 'agency_number',
  name = 'name',
  agentList = 'agentList',
  rmds = 'rmds',
  levelDivisor = 'level_divisor',
  startingMultiplier = 'starting_multiplier',
  agencyType = 'agency_type',
  mga = 'mga',
  contactFirstName = 'contact_first_name',
  contactLastName = 'contact_last_name',
  contactEmail = 'contact_email',
  contactPhone = 'contact_phone',
  agencyLead = 'agency_lead',
  companyLogoLink = 'companyLogoLink',
  officePhoneNumbers = 'officePhoneNumbers',
  officeEmailAddress = 'officeEmailAddress',
  addresses = 'addresses',
  websites = 'websites',
  socials = 'socials',
  carriers = 'carriers',
  stateLicenses = 'stateLicenses',
  statusActivity = 'statusActivity',
  relationshipWithAG = 'relationshipWithAG',
  agencyStatus = 'agencyStatus',
  headshot = 'head_shot',
  mga_goals = 'mga_goals',
  branding = 'branding',
}
